var map = {
	"./ITEC.png": "f71f",
	"./创客中国.png": "312e",
	"./发明创业奖-创新奖_一等奖.png": "c579",
	"./多模异构.png": "13db",
	"./日内瓦国际发明奖_金奖.png": "bcef",
	"./物联网示范项目公示.png": "6a57"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ed67";